import React, { useState } from 'react'
import { TeamRound } from '../types'

interface ConfirmLowScoresProps {
  teamRound: TeamRound,
  allowRoundComplete: (value: boolean) => void
}

export default function ConfirmLowScores({ teamRound, allowRoundComplete }: ConfirmLowScoresProps) {
  const { players } = teamRound
  const initialLowScorePlayers = []

  players.forEach((player) => {
    if (!player.canceled && player.holesCompleted > 8 && player.netScoreRelativeToPar <= -9) {
      initialLowScorePlayers.push(
        {
          id: player.id,
          user: player.user,
          grossScore: player.grossScore,
          confirmed: false
        }
      )
    }
  })

  const [lowScorePlayers, setLowScorePlayers] = useState(initialLowScorePlayers)

  const handleLowScoreConfirmation = function(playerId: Number) {
    const updatedLowScorePlayers =
      lowScorePlayers.map((player) => {
        if (player.id == playerId) {
          player.confirmed = !player.confirmed
        }

        return player
      })

    setLowScorePlayers(updatedLowScorePlayers)

    if (lowScorePlayers.every((player) => { return player.confirmed })) {
      allowRoundComplete(true)
    } else {
      allowRoundComplete(false)
    }
  }

  return (
    <div className="card-v2">
      <div className="container">
        <div className="screen-heading" style={{ marginTop: "2rem" }}>
          <h2 className="screen-title">{`Confirm Low ${lowScorePlayers.length > 1 ? "Scores" : "Score"}`}</h2>
          <p style={{ marginBottom: "0.5rem" }}>
            {lowScorePlayers.length > 1
              ? "Your scores are significantly lower than average. Confirm the hole by hole scores are correct or edit them if incorrect."
              : `${lowScorePlayers[0].user.firstName}'s scores are significantly lower than average. Confirm the hole by hole scores are correct or edit them if incorrect.`
            }
          </p>

          <ul className="list-group list-group--borderless">
            {lowScorePlayers.map((player, i) => {
              return (
                <li key={i}>
                  <div>
                    <label className="checkbox-input">
                      <div className="checkbox-control">
                        <input type="checkbox" onChange={() => { handleLowScoreConfirmation(player.id) }} value={player.confirmed} />
                        <div className="faux-checkbox"></div>
                      </div>
                      <div className="label">
                        {`Yes, ${player.user.firstName}'s actual score was ${player.grossScore}`}
                      </div>
                    </label>
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}
